import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/hero/Hero";
import HeroFeatures from "../../components/hero/HeroFeatures";
import AboutSection from "../../components/about/about";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import FeatureSection from "../../components/FeatureSection/FeatureSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import IndustriesMarqueeSection from "../../components/IndustriesMarqueeSection/IndustriesMarqueeSection";
import IndustriesSection from "../../components/Industries/Industries";
import ContactSection from "../../components/ContactSection/ContactSection";

import BlogSection from "../../components/BlogSection/BlogSection";
import StatsSection from "../../components/StatsSection/StatsSection";
import FaqSection from "../../components/FaqSection/FaqSection";
import CtaSection from "../../components/CtaSection/CtaSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import SEO from "../../components/SEO/SEO";


const HomePage: React.FC = () => {
  return (
    <Fragment>
      <SEO 
        title="TorqAI | AI Automation Agency & Intelligent Digital Workforce" 
        description="Scale your business with TorqAI. Our AI agents handle your calls, social media, hiring, and sales 24/7 so your team can focus on closing deals."
        canonicalUrl="https://torqai.ca"
        schema={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "TorqAI",
          "url": "https://torqai.ca"
        }}
      />
      <div className='ai-agency'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <HeroSection />
            <StatsSection />
            <ServiceSection />
            <FeatureSection />
            <HeroFeatures />
            <IndustriesSection />
            <ContactSection />

            <FaqSection />
            <CtaSection />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default HomePage;
